import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f6f89a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "days" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["href"]

import articles, { State } from '@/store/articles/home';
import { RootState } from '@/store/protocols'
import i18, { State as I18State } from '@/store/i18';
import * as filters from '@/views/filters';
import Layout from '@/views/layouts/desktop/Root.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import Menus from './Menus.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[articles.name])
const configData = computed<RootState>(() => store.state.moviesConfig)
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].article)

function onChangeDay(v: number) {
    data.value.feedIndex = v
    data.value.feedsVisible = true
}

function date(value: number) {
    if (isNaN(value)) {
        return '--'
    }
    let dt = new Date(value * 1000);
    let today = new Date()
    if (dt.getFullYear() == today.getFullYear() && dt.getMonth() == today.getMonth() && dt.getDate() == today.getDate()) {
        return lang.value.today
    }
    return filters.n2(dt.getMonth() + 1) + '-' + filters.n2(dt.getDate())
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, { "left-width": 220 }, {
    "left-side": _withCtx(() => [
      _createVNode(Menus)
    ]),
    "top-bar": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            class: _normalizeClass({ on: -1 == _unref(data).feedIndex }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onChangeDay(-1)))
          }, _toDisplayString(_unref(lang).latest7), 3),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).feeds, (feed, i) => {
            return (_openBlock(), _createElementBlock("a", {
              class: _normalizeClass({ on: i == _unref(data).feedIndex }),
              onClick: ($event: any) => (onChangeDay(i))
            }, _toDisplayString(date(feed.user.dateline)), 11, _hoisted_3))
          }), 256)),
          _createElementVNode("a", {
            class: "download on",
            href: _unref(configData).downloadUrl,
            target: "_blank"
          }, _toDisplayString(_unref(lang).download), 9, _hoisted_4)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})